"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentValuesAssertions = exports.ComponentValueValidated = exports.ComponentValuesRequirement = void 0;
const enums_1 = require("../enums");
const COMPONENT_VALUES_REQUIREMENT_ID = 'req_cadstromcval000000000000000000000000';
exports.ComponentValuesRequirement = {
    id: COMPONENT_VALUES_REQUIREMENT_ID,
    slug: 'cadstrom.component_value',
    slugPrefix: 'CVAL',
    name: 'Component Values',
    description: 'Asserts that a resistor, capacitor, or inductor value from the design can be compared to the resolved package value, and that the comparable values match.',
};
exports.ComponentValueValidated = {
    id: 'asrt_cvalvalidated00000000000000000000000',
    slug: 'cadstrom.component_value.validated',
    requirementDefinitionId: COMPONENT_VALUES_REQUIREMENT_ID,
    name: 'Component value must match the resolved package value',
    description: 'The design value and resolved package value must both be readable, and the comparable resistor, capacitor, or inductor value must match the resolved package value.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.ComponentValuesAssertions = [exports.ComponentValueValidated];
//# sourceMappingURL=component-values.js.map